import type { PropsWithChildren } from "react";
import Head from "next/head";
import { RemiImage } from "@remi/next-ui";

import roofImage from "../../../public/images/roofer.webp";
import icon from "../../../public/remi-logo-updated.svg";

//default react props
export const SignInWrapper = ({ children, title }: PropsWithChildren<{ title: string }>) => (
  <>
    <Head>
      <title>{title}</title>
    </Head>
    <main className="flex h-dvh items-center justify-center p-4 text-black">
      <div className="relative flex h-full flex-[2] flex-col p-3 sm:min-w-[400px] sm:p-4">
        <div className="absolute top-6 left-6 sm:top-8 sm:left-8">
          <RemiImage src={icon} alt="Logo" width={63} height={22} />
        </div>
        {children}
      </div>
      <div className="relative hidden h-full flex-[3] rounded-lg lg:flex">
        <RemiImage
          priority={true}
          src={roofImage}
          className="rounded-lg"
          alt="Roofer"
          fill
          objectFit="cover"
          objectPosition="bottom"
          sizes={"(max-width: 1024px) 0vw, 50vw"}
        />
      </div>
    </main>
  </>
);
